export default __webpack_public_path__ + "static/media/mountains.b310e201.png";